import IconButton from 'components/Buttons/IconButton.index';
import ItemButton from 'components/Buttons/ItemButton/ItemButton.index';
import PlayerAudioButton from 'components/Buttons/PlayerAudioButton.index';
import SubscriberInfo from 'components/Topbar/SubscriberInfo/SubscriberInfo.index';
import SubscribeNowBannerButton from 'components/Buttons/SubscribeNowBannerButton.index';
import VersaoDigitalButton from 'components/Buttons/VersaoDigitalButton.index';
import { useIcon } from 'hooks/useIcon';
import { AssetsContext } from 'providers/Assets';
import { DrawersContext } from 'providers/DrawersProvider';

import React, { useContext } from 'react';
import { useRouter } from 'next/router';
import { SessionDataContext } from 'providers/Session';
import { useKeycloak } from '@react-keycloak/ssr'

const buttons = {
  topbarButtonDigitalMobile: {
    customProps: {
      color: 'black',
    },
    hideInMobile: false,
  },
  topbarButtonDigitalDesktop: {
    customProps: {
      color: 'neutral7',
    },
    customCss: {
      button: {
        fill: '#A6A6A6',
        pr: '0',
      },
      label: {
        color: '#202020',
        fontWeight: 500,
        fontSize: '14px',
      },
    },
    value: 'DIGITAL',
    hideInMobile: false,
  },
  topbarButtonMenuMobile: {
    customProps: {
      color: 'black',
    },
    cssContainer: {
      mr: '$4',
    },
    hideInMobile: false,
  },
  topbarButtonMenuDesktop: {
    customProps: {
      color: '#202020',
    },
    hideInMobile: false,
  },
  topbarButtonPhoneMobile: {
    customProps: {
      color: 'black',
    },
    hideInMobile: false,
  },
  topbarButtonPhoneDesktop: {
    customCss: {
      button: {
        fill: '#A6A6A6',
      },
      label: {
        color: '#202020',
        fontWeight: 500,
        fontSize: '14px',
      },
    },
    value: 'ÁUDIO',
    hideInMobile: false,
  },
  topbarButtonProfilehMobile: {
    customProps: {
      color: 'basicWhite',
    },
    hideInMobile: false,
  },
  topbarButtonProfileDesktop: {
    customProps: {
      color: 'black',
      iconLeft: undefined,
    },
    customCss: {
      label: {
        fontWeight: 500,
        fontSize: '16px',
        p: '0',
      },
    },
    value: 'ENTRAR',
    hideInMobile: false,
  },
  topbarButtonSearchMobile: {
    customProps: {
      color: 'basicWhite',
    },
    hideInMobile: false,
  },
  topbarButtonSearchDesktop: {
    customProps: {
      color: 'black',
    },
    hideInMobile: false,
  },
  topbarCompanyLogoDesktop: {
    customProps: {
      color: 'basicWhiteAlpha800',
    },
    hideInMobile: false,
  },
  topbarActions: {
    cssTopbarItem: {
      borderRight: '1px solid #E3F1FC',
      px: '$2',
      py: '$0',
      color: '#E3F1FC',
      fontSize: '14px',
      '&:last-child': {
        borderRight: 'none',
      },
    },
    hideInMobile: false,
  },
  topbarTopItems: {
    cssTopbarItem: {
      color: '#202020',
      mx: '$2',
      px: '$2',
      py: '$1',
      fontSize: '14px',
      fontWeight: 500,
      textTransform: 'uppercase',
      width: 'max-content',
    },
    hideInMobile: false,
  },
  topbarTopItemsRight: {
    customCss: {
      label: {
        color: '#202020',
        fontSize: '14px',
        fontWeight: 400,
        width: 'max-content',
      },
    },
    hideInMobile: false,
  },
};

export const TopbarMobileSlotLeft = () => {
  const drawersContext = useContext(DrawersContext);

  return (
    <>
      <IconButton
        icon={useIcon('IcHamburguerMobile')}
        onClick={() =>
          drawersContext.handleSideMenuLeft({
            open: !drawersContext.sideMenuLeftState.open,
          })
        }
      />
    </>
  );
};
export const TopbarMobileSlotRight = () => {
  return (
    <>

    </>
  );
};
export const TopbarTopSlotLeft = () => {
  return (
    <>
    </>
  );
};
export const TopbarTopSlotRight = () => {
  return (
    <>
      {/* FIXME rm classi */}
      <ItemButton
        href='https://classi.com.br'
        value='Classi'
        {...buttons.topbarTopItemsRight}
      />
      <ItemButton
        href='https://opopular.com.br/'
        value='Jornal O Popular'
        {...buttons.topbarTopItemsRight}
      />
      <ItemButton
        href='https://www.jornaldotocantins.com.br'
        value='Jornal do Tocantins'
        {...buttons.topbarTopItemsRight}
      />
    </>
  );
};
export const TopbarDesktopSlotRight = () => {
  const assetsContext = useContext(AssetsContext);
  const sessionData = useContext(SessionDataContext);
  const router = useRouter();
  const {keycloak} = useKeycloak();
  const banners = assetsContext?.assets?.banners;
  const bannerAssine = banners.find((i) => i.name === 'BannerAssineAgora');
  const routerRedirectUrl = window.location.href;

  return (
    <>
      <SubscribeNowBannerButton
        alt='Assine'
        colorSchema='secondary'
        href={process.env.NEXT_PUBLIC_URL_LOJA || ''}
        imgSrc={bannerAssine.url}
        imgHeight={bannerAssine.height}
        imgWidth={bannerAssine.width}
        isUnstyled
      />
      {/*<SubscriberInfo*/}
      {/*  amountLeft={sessionData?.inscricaoDegustador.creditosDegustadorList[0].quantidade}*/}
      {/*  onAnonymousClick={() => {*/}
      {/*    const url = window.location.origin + `/entrar?&r=${routerRedirectUrl}`*/}
      {/*    window.location.assign(url)*/}
      {/*  }}*/}
      {/*  onGuestClick={() => {*/}
      {/*    const url = process.env.NEXT_PUBLIC_URL_LOJA ? process.env.NEXT_PUBLIC_URL_LOJA : ''*/}
      {/*    if (url) {*/}
      {/*      window.location.assign(url)*/}
      {/*    }*/}
      {/*  }}*/}
      {/*  onSubscriberClick={() => console.log('subscriber')}*/}
      {/*  username={sessionData?.emailUsuario.split('@')[0] || ''}*/}
      {/*  type={keycloak?.authenticated?'ASSINANTE' : 'anonymous'}*/}
      {/*/>*/}
    </>
  );
};
export const TopbarExtraSlotRight = () => {
  return (
    <>
      <VersaoDigitalButton 
        onClick={() => window.open('https://daqui.opopular.com.br/digital')}
        icon={useIcon('IcVersaoDigitalCinzaClaro')}
        id='digital-menu' 
      />
    </>
  );
};
